import React from "react";
import { AiOutlineStop } from "react-icons/ai";

const NoAccessPage = () => {
  return (
    <div className="flex items-center justify-center   p-4 overflow-hidden">
      <div className="bg-white-A700/50 backdrop-blur-md border border-blue-500 rounded-3xl px-6 py-20 my-28 sm:px-10 text-center shadow-xl max-w-md w-full animate-fade-in transition-all">
        <div className="flex justify-center mb-5 text-red-500">
          <AiOutlineStop
            size={60}
            className="animate-pulse"
            aria-hidden="true"
          />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-red-500 mb-3">
          Access Denied
        </h1>
        <p className="text-gray-800 text-sm sm:text-base leading-relaxed">
          You do not have permission to view this page. If you think this is a
          mistake, please contact your administrator.
        </p>
      </div>
    </div>
  );
};

export default NoAccessPage;
